import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
// Servicio
import { ClientesService } from '../../../services/Clientes.service';
import { EmpleadosServicio } from '../../../services/empleado.service';
import { PrestamosService } from '../../../services/prestamos.service';
import { ActivatedRoute, Router } from '@angular/router';

// Helpers
import { Helper } from '../../../helpers/helper';

// Modal
import { AlertasModales } from '../../../helpers/alertasModales';
import {DecimalPipe} from "@angular/common";

@Component({
  selector: 'app-editar',
  templateUrl: './editar.component.html',
  styleUrls: ['./editar.component.css']
})
export class EditarPrestamoComponent implements OnInit {
  form: FormGroup;
  cedulas: Observable<Array<any>>;
  loadingRnc: boolean;
  prestamo: any;
  tablaAmortizacion: Array<any> = [];
  fechaPrestamo: NgbDateStruct;
  fechaInicia: NgbDateStruct;
  diasFeriados: any = [];
  otraFormaPago = false;
  prestamoFormaPago: string;
  gasto: any;
  gastoC: any;
  montoIncremento: any;
  Math: any;
  loading = false;
  loaded = false;
  constructor(public _prestamo: PrestamosService,
              public CS: ClientesService,
              private helper: Helper,
              private modals: AlertasModales,
              private params: ActivatedRoute,
              private router: Router,
              private empleadoService: EmpleadosServicio) {
    this.Math = Math;
    this.initFormulario();
    this.setFormulario();
  }

  ngOnInit() {
    if (localStorage.getItem('nuevoCliente')) {
      this.clientePorCedula(localStorage.getItem('nuevoCliente'));
      localStorage.removeItem('nuevoCliente');
    }

    // Asignar ID del empleado al formulario

    this.form.get('ID_EMPLEADO').setValue(this.empleadoService.datosEmpleado.ID_EMPLEADO);

  }


  // Cargar datos cliente por su cedula
  private clientePorCedula(ID): void {
    this.loadingRnc = true;
    this.CS.obtenerClientePorID(ID).subscribe((res: any) => {
      this.form.get('nombreCliente').setValue(`${res.nombre} ${res.apellido}`);
      this.form.get('nombreComercial').setValue(res.apodo);
      this.form.get('telefono').setValue(res.telefono);
      this.form.get('ID_CLIENTE').setValue(res.ID_CLIENTE);
      this.form.get('rutaNombre').setValue(res.ruta_nombre);
      this.form.get('rutaID').setValue(res.ID_RUTA);
      this.form.get('requiere_aprobacion').setValue(res.requiere_aprobacion);
      this.form.get('requiere_aprobacion_monto').setValue(res.requiere_aprobacion_monto);
      this.loadingRnc = false;
    });
  }

  resetClienteForm() {
    const cedula = this.form.get('cedulaCliente').value;
    this.form.reset();
    this.form.get('cedulaCliente').setValue(cedula);
  }

  private initFormulario(): void {
    // Cargar dias feriados
    this._prestamo.obtenerDiasFeriados().subscribe(res => this.diasFeriados = res);

    // Inicializar formulario para cliente
    this.form = new FormGroup({
      'cedula': new FormControl({value: '', disabled: true}),
      'nombre': new FormControl({value: '', disabled: true}),
      'nombreComercial': new FormControl({value: '', disabled: true}),
      'telefono': new FormControl({value: '', disabled: true}),
      'ID_CLIENTE': new FormControl('', Validators.required),
      'ID_EMPLEADO': new FormControl('', Validators.required),
      'ID_PRESTAMO': new FormControl('', Validators.required),
      'nombreEmpleado': new FormControl(''),
      'ruta': new FormControl(''),
      'ID_RUTA': new FormControl('', Validators.required),
      'fechaPrestamo': new FormControl(''),
      'fechaInicia': new FormControl(''),
      'fechaVence': new FormControl(''),
      'requiere_aprobacion': new FormControl(''),
      'requiere_aprobacion_monto': new FormControl('')
    });
  }

  private setFormulario(): void {
    this.params.params.subscribe(params => {
      if (!isNaN(params.id)) {
        this._prestamo.obtenerPrestamoParaEditar(params.id).subscribe((data: any) => {
          if (data) {
            if (data.estado !== 0 && data.total_pagado !== 0) {
              // this.router.navigate(['/prestamo', params.id]);
            } else {

              this.form.get('ID_PRESTAMO').setValue(params.id);
              this.form.get('cedula').setValue(data.cedula);
              this.form.get('nombre').setValue(data.nombreCliente);
              this.form.get('telefono').setValue(data.telefono);
              this.form.get('ID_CLIENTE').setValue(data.ID_CLIENTE);
              this.form.get('ID_EMPLEADO').setValue(data.ID_EMPLEADO);
              this.form.get('ID_RUTA').setValue(data.ID_RUTA);
              this.form.get('ruta').setValue(data.ruta);
              this.form.get('fechaPrestamo').setValue(data.fecha_prestamo);
              this.form.get('fechaInicia').setValue(data.fecha_inicio);
              this.form.get('nombreEmpleado').setValue(data.nombreEmpleado);

              let fechaarr = data.fecha_prestamo.split('-');
              this.fechaPrestamo = {
                year: parseFloat(fechaarr[0]),
                month: parseFloat(fechaarr[1]),
                day: parseFloat(fechaarr[2].split('T')[0])
              };

              fechaarr = data.fecha_inicio.split('-');
              this.fechaInicia = {
                year: parseFloat(fechaarr[0]),
                month: parseFloat(fechaarr[1]),
                day: parseFloat(fechaarr[2].split('T')[0])
              };

              const totalCuotas = (data.plazoEnDias / data.formaPago);
              this.prestamo = {
                tazaInteres: data.tazaInteres,
                capital: data.capital,
                gastoCierre: data.gasto_cierre,
                moraPorciento: data.moraPorciento,
                plazo: data.plazo,
                tipoPlazo: data.tipoPlazo,
                plazoEnDias: data.plazoEnDias,
                totalInteres: data.totalInteres,
                totalCuotas: totalCuotas,
                montoCuotas: (data.capital + data.totalInteres) / totalCuotas,
                montoTotal: data.capital + data.totalInteres,
                interesAcomulado: data.interesAcomulado,
                formaPago: String(data.formaPago),
                diasExcluir: String(data.diasExcluir),
                tipoGastoCierre: null
              };

              this._prestamo.obtenerConfiguracionPrestamo(0)
                .subscribe((res: any) => {
                  this.gastoC = data.gasto_cierre;
                  this.prestamo.tipoGastoCierre = res.pn_tipo_gasto_cierre;
                  this.gasto = res.pn_monto_gasto_cierre;
                  this.montoIncremento = res.pn_monto_incremento;
                  const data1 = {
                    tipo: this.prestamo.tipoGastoCierre,
                    monto_gasto_cierre: this.gasto,
                    capital_prestamo: this.prestamo.capital,
                    monto_incremento: this.montoIncremento
                  };

                  //this.prestamo.gastoCierre = this._prestamo.calcularGastoCierre(data1);
                  
                  this.prestamo.tipoInteres = data.tipoInteres
                  console.log(this.prestamo);
                  this.formChange();
                  this.prestamo.gastoCierre = data.gasto_cierre;
                  this.gastoC = this.prestamo.gastoCierre;
                });
              
              setTimeout(() => {

                this.loaded = true;
              }, 1);

            }
          } else {
            this.router.navigate(['/404']);
          }
        }, err => {
          console.error(err);
        });
      } else {

        this.router.navigate(['/404']);
      }
    }, () => {
      this.router.navigate(['/404']);
    });
  }

/*
  formChange() {

    if (parseFloat(this.prestamo.capital) > 0) {

      if (parseFloat(this.gastoC) >= 0) {
        this.prestamo.gastoCierre = this.gastoC;
        console.log('el bending');
        console.log(this.prestamo);
      }
      const formaPago = (this.otraFormaPago && this.prestamoFormaPago ? this.prestamoFormaPago : this.prestamo.formaPago);
      // Plazo en dias
      this.prestamo.plazoEnDias = parseFloat(this.prestamo.plazo) * parseFloat(this.prestamo.tipoPlazo);

      // total de cuotas
      this.prestamo.totalCuotas = Math.ceil(parseFloat(this.prestamo.plazoEnDias) / parseFloat(formaPago)),

        // interes acomulado
        this.prestamo.interesAcomulado = parseFloat(this.prestamo.plazoEnDias) / 30 *
          parseFloat((this.prestamo.tazaInteres ? this.prestamo.tazaInteres : 0));

      // total interes
      this.prestamo.totalInteres = Math.ceil(parseFloat(this.prestamo.interesAcomulado) / 100 * parseFloat(this.prestamo.capital));

      // monto cuotas
      this.prestamo.montoCuotas = (parseFloat(this.prestamo.capital) +
        parseFloat(this.prestamo.totalInteres)) /
        parseFloat(this.prestamo.totalCuotas);

      // Monto total
      this.prestamo.montoTotal = Math.ceil(parseFloat(this.prestamo.totalCuotas) * parseFloat(this.prestamo.montoCuotas));

      let saldoP = parseFloat(this.prestamo.montoTotal);
      this.tablaAmortizacion = [];
      const { year, month, day } = this.fechaInicia;
      const fechaInicia = this.helper.getMoment(`${year}-${month}-${day}`);

      for (let i = 1; i <= this.prestamo.totalCuotas; i++) {
        if (parseFloat(formaPago) !== 30) {
          if (parseFloat(this.prestamo.diasExcluir) == 2) { // Excluir domingo
            fechaInicia.add((fechaInicia.day() == 0 ? 1 : 0), 'day');
          } else if (parseFloat(this.prestamo.diasExcluir) == 3) { // Excluir sabado y domingo

            fechaInicia.add(
              (fechaInicia.day() == 6 ? 2 : (fechaInicia.day() == 0 ? 1 : 0)),
              'day'
            );
          }
        }

        saldoP -= parseFloat(this.prestamo.montoCuotas);
        this.tablaAmortizacion.push({
          numero_cuota: i,
          fechaVence: fechaInicia.format(),
          capital: Math.ceil(parseFloat(this.prestamo.capital) / parseFloat(this.prestamo.totalCuotas)),
          interes: Math.ceil(parseFloat(this.prestamo.totalInteres) / parseFloat(this.prestamo.totalCuotas)),
          montoCuotas: Math.ceil(this.prestamo.montoCuotas),
          saldoPrestamo: (i !== parseFloat(this.prestamo.totalCuotas)) ? Math.ceil(saldoP) : 0
        });

        if (parseFloat(formaPago) == 30) {
          fechaInicia.add(1, 'month');

        } else {
          if (parseFloat(this.prestamo.diasExcluir) == 2) { // Excluir domingo
            fechaInicia.add(parseFloat(formaPago) + (fechaInicia.day() == 0 ? 1 : 0), 'day');
          } else if (parseFloat(this.prestamo.diasExcluir) == 3) { // Excluir sabado y domingo

            fechaInicia.add(
              parseFloat(formaPago) + (fechaInicia.day() == 6 ? 2 : (fechaInicia.day() == 0 ? 1 : 0)),
              'day'
            );

          } else {
            fechaInicia.add(parseFloat(formaPago), 'day');
          }
        }

      }
    } else {
      this.tablaAmortizacion = [];
      // this.prestamo.capital = '';
      this.prestamo.totalInteres = 0;
      this.prestamo.montoCuotas = 0;
      this.prestamo.montoTotal = 0;
    }
    const data1 = {
      tipo: this.prestamo.tipoGastoCierre,
      monto_gasto_cierre: this.gasto,
      capital_prestamo: this.prestamo.capital,
      monto_incremento: this.montoIncremento
    };

    this.prestamo.gastoCierre = this._prestamo.calcularGastoCierre(data1);
    this.gastoC = this.prestamo.gastoCierre;
  }*/

  formChange() {
    if (parseFloat(this.prestamo.capital) > 0) {
      if (parseFloat(this.gastoC) >= 0) {
        this.prestamo.gastoCierre = this.gastoC;
        console.log('el bending');
        console.log(this.prestamo);
      }
      const formaPago = (this.otraFormaPago && this.prestamoFormaPago ? this.prestamoFormaPago : this.prestamo.formaPago);
      let saldoP = parseFloat(this.prestamo.montoTotal);
      this.tablaAmortizacion = [];
      const { year, month, day } = this.fechaInicia;
      const fechaInicia = this.helper.getMoment(`${year}-${month}-${day}`);

      if (this.prestamo.tipoInteres === 'Lineal') {
        // Plazo en dias
        this.prestamo.plazoEnDias = parseFloat(this.prestamo.plazo) * parseFloat(this.prestamo.tipoPlazo);

        // total de cuotas
        this.prestamo.totalCuotas = Math.ceil(parseFloat(this.prestamo.plazoEnDias) / parseFloat(formaPago)),

          // interes acomulado
          this.prestamo.interesAcomulado = parseFloat(this.prestamo.plazoEnDias) / 30 *
            parseFloat((this.prestamo.tazaInteres ? this.prestamo.tazaInteres : 0));

        // total interes
        this.prestamo.totalInteres = Math.ceil(parseFloat(this.prestamo.interesAcomulado) / 100 * parseFloat(this.prestamo.capital));

        // monto cuotas
        this.prestamo.montoCuotas = (parseFloat(this.prestamo.capital) +
            parseFloat(this.prestamo.totalInteres)) /
          parseFloat(this.prestamo.totalCuotas);

        // Monto total
        this.prestamo.montoTotal = Math.ceil(parseFloat(this.prestamo.totalCuotas) * parseFloat(this.prestamo.montoCuotas));
        for (let i = 1; i <= this.prestamo.totalCuotas; i++) {
          if (parseFloat(formaPago) !== 30) {
            if (parseFloat(this.prestamo.diasExcluir) == 2) { // Excluir domingo
              fechaInicia.add((fechaInicia.day() == 0 ? 1 : 0), 'day');
            } else if (parseFloat(this.prestamo.diasExcluir) == 3) { // Excluir sabado y domingo

              fechaInicia.add(
                (fechaInicia.day() == 6 ? 2 : (fechaInicia.day() == 0 ? 1 : 0)),
                'day'
              );
            }
          }

          saldoP -= parseFloat(this.prestamo.montoCuotas);

          this.tablaAmortizacion.push({
            numero_cuota: i,
            fechaVence: fechaInicia.format(),
            capital: parseFloat(this.prestamo.capital) / parseFloat(this.prestamo.totalCuotas),
            interes: parseFloat(this.prestamo.totalInteres) / parseFloat(this.prestamo.totalCuotas),
            montoCuotas: Math.ceil(this.prestamo.montoCuotas),
            saldoPrestamo: (i !== parseFloat(this.prestamo.totalCuotas)) ? Math.ceil(saldoP) : 0
          });

          if (parseFloat(formaPago) === 30) {
            fechaInicia.add(1, 'month');

          } else {
            if (this.prestamo.diasExcluir === 2) { // Excluir domingo
              fechaInicia.add(parseFloat(formaPago) + (fechaInicia.day() === 0 ? 1 : 0), 'day');
            } else if (this.prestamo.diasExcluir === 3) { // Excluir sabado y domingo

              fechaInicia.add(
                parseFloat(formaPago) + (fechaInicia.day() === 6 ? 2 : (fechaInicia.day() === 0 ? 1 : 0)),
                'day'
              );

            } else {
              fechaInicia.add(parseFloat(formaPago), 'day');
            }
          }
        }
      }
      if (this.prestamo.tipoInteres === 'Simple') {
        // Plazo en dias
        this.prestamo.plazoEnDias = parseFloat(this.prestamo.plazo) * parseFloat(this.prestamo.tipoPlazo);

        // total de cuotas
        this.prestamo.totalCuotas = Math.ceil(parseFloat(this.prestamo.plazoEnDias) / parseFloat(formaPago));

        // interes acomulado
        this.prestamo.interesAcomulado = parseFloat(this.prestamo.plazoEnDias) / 30 *
          parseFloat((this.prestamo.tazaInteres ? this.prestamo.tazaInteres : 0));
        // interes de una cuota
        let interes = (this.prestamo.capital * this.prestamo.tazaInteres) / 100, interesAux;
        interes += this.prestamo.interesAcomulado;
        // tslint:disable-next-line:comment-format
        //para calcular el saldo del prestamo
        interesAux = interes;
        const monto = this.prestamo.capital / this.prestamo.totalCuotas;
        // tslint:disable-next-line:comment-format
        //monto cuotas
        this.prestamo.montoCuotas = (monto + interes) - this.prestamo.interesAcomulado;
        this.prestamo.montoTotal = this.prestamo.capital;
        let saldoPrestamo = parseFloat(this.prestamo.montoTotal);
        for (let i = 1; i <= this.prestamo.totalCuotas; i++) {
          interesAux -= this.prestamo.interesAcomulado;
          saldoPrestamo += interesAux;
        }
        for (let i = 1; i <= this.prestamo.totalCuotas; i++) {
          if (parseFloat(formaPago) !== 30) {
            if (this.prestamo.diasExcluir === 2) { // Excluir domingo
              fechaInicia.add((fechaInicia.day() === 0 ? 1 : 0), 'day');
            } else if (this.prestamo.diasExcluir === 3) { // Excluir sabado y domingo

              fechaInicia.add(
                (fechaInicia.day() === 6 ? 2 : (fechaInicia.day() === 0 ? 1 : 0)),
                'day'
              );
            }
          }


          interes -= this.prestamo.interesAcomulado;
          saldoPrestamo -= monto + interes;
          // total interes
          this.prestamo.totalInteres += interes;
          // Monto total
          this.prestamo.montoTotal += interes;

          this.tablaAmortizacion.push({
            numero_cuota: i,
            fechaVence: fechaInicia.format(),
            capital: parseFloat(this.prestamo.capital) / parseFloat(this.prestamo.totalCuotas),
            interes: interes,
            montoCuotas: monto + interes,
            saldoPrestamo: (i === parseFloat(this.prestamo.totalCuotas)) ? 0 : Math.ceil(saldoPrestamo)
          });

          if (parseFloat(formaPago) === 30) {
            fechaInicia.add(1, 'month');

          } else {
            if (this.prestamo.diasExcluir === 2) { // Excluir domingo
              fechaInicia.add(parseFloat(formaPago) + (fechaInicia.day() === 0 ? 1 : 0), 'day');
            } else if (this.prestamo.diasExcluir === 3) { // Excluir sabado y domingo

              fechaInicia.add(
                parseFloat(formaPago) + (fechaInicia.day() === 6 ? 2 : (fechaInicia.day() === 0 ? 1 : 0)),
                'day'
              );

            } else {
              fechaInicia.add(parseFloat(formaPago), 'day');
            }
          }
        }
      }
      if (this.prestamo.tipoInteres === 'Bancario') {
        // Plazo en dias
        this.prestamo.plazoEnDias = parseFloat(this.prestamo.plazo) * parseFloat(this.prestamo.tipoPlazo);

        // total de cuotas
        this.prestamo.totalCuotas = Math.ceil(parseFloat(this.prestamo.plazoEnDias) / parseFloat(formaPago)),

          // interes acomulado
          this.prestamo.interesAcomulado = parseFloat(this.prestamo.plazoEnDias) / 30 *
            parseFloat((this.prestamo.tazaInteres ? this.prestamo.tazaInteres : 0));

        // total interes
        this.prestamo.totalInteres = 0;



        // Monto total
        this.prestamo.montoTotal = 0;

        let saldoPrestamo = parseFloat(this.prestamo.montoTotal);
        let num = (1 + (this.prestamo.tazaInteres / 100));
        num = Math.pow(num, this.prestamo.plazo);
        num *= (this.prestamo.tazaInteres / 100);
        let denom = (1 + (this.prestamo.tazaInteres / 100));
        denom = Math.pow(denom, this.prestamo.plazo);
        denom -= 1;
        const pago = this.prestamo.capital * (num / denom);
        let balance = this.prestamo.capital, interes = (this.prestamo.tazaInteres / 100) * this.prestamo.capital;
        let interesAux = interes;
        for (let i = 1; i <= this.prestamo.totalCuotas; i++) {
          interesAux -= this.prestamo.interesAcomulado;
          saldoPrestamo += interesAux;
        }
        interesAux = interes;
        let capitalCuota = 0;
        // tslint:disable-next-line:comment-format
        //monto cuotas
        this.prestamo.montoCuotas = ((pago - interes) + interesAux);
        for (let i = 1; i <= this.prestamo.plazo; i++) {
          if (parseFloat(formaPago) !== 30) {
            if (this.prestamo.diasExcluir === 2) { // Excluir domingo
              fechaInicia.add((fechaInicia.day() === 0 ? 1 : 0), 'day');
            } else if (this.prestamo.diasExcluir === 3) { // Excluir sabado y domingo

              fechaInicia.add(
                (fechaInicia.day() === 6 ? 2 : (fechaInicia.day() === 0 ? 1 : 0)),
                'day'
              );
            }
          }
          capitalCuota = pago - interes;

          this.tablaAmortizacion.push({
            numero_cuota: i,
            fechaVence: fechaInicia.format(),
            capital: Math.ceil(capitalCuota),
            interes: Math.ceil(interes),
            montoCuotas: Math.ceil(capitalCuota + interes),
            saldoPrestamo: (i === parseFloat(this.prestamo.totalCuotas)) ? 0 : Math.ceil(saldoPrestamo)
          });
          // total interes
          this.prestamo.totalInteres += Math.ceil(interes);
          // Monto total
          this.prestamo.montoTotal += Math.ceil(interes);
          balance -= capitalCuota;
          interes = (this.prestamo.tazaInteres / 100) * balance;

          if (parseFloat(formaPago) === 30) {
            fechaInicia.add(1, 'month');

          } else {
            if (this.prestamo.diasExcluir === 2) { // Excluir domingo
              fechaInicia.add(parseFloat(formaPago) + (fechaInicia.day() === 0 ? 1 : 0), 'day');
            } else if (this.prestamo.diasExcluir === 3) { // Excluir sabado y domingo

              fechaInicia.add(
                parseFloat(formaPago) + (fechaInicia.day() === 6 ? 2 : (fechaInicia.day() === 0 ? 1 : 0)),
                'day'
              );

            } else {
              fechaInicia.add(parseFloat(formaPago), 'day');
            }
          }
        }
        this.prestamo.montoTotal += this.prestamo.capital;



      }
      if (this.prestamo.tipoInteres === 'Solo interes') {
        // Plazo en dias
        this.prestamo.plazoEnDias = parseFloat(this.prestamo.plazo) * parseFloat(this.prestamo.tipoPlazo);

        // total de cuotas
        this.prestamo.totalCuotas = this.prestamo.plazo;

        // interes acomulado
        this.prestamo.interesAcomulado = parseFloat(this.prestamo.plazoEnDias) / 30 *
          parseFloat((this.prestamo.tazaInteres ? this.prestamo.tazaInteres : 0));

        // total interes
        this.prestamo.totalInteres = 0;



        let saldoPrestamo = 0;
        const interes = Math.ceil((this.prestamo.tazaInteres / 100) * this.prestamo.capital);
        // Monto total
        this.prestamo.montoTotal = this.prestamo.capital + interes;
        this.prestamo.totalInteres = interes;
        for (let i = 1; i <= this.prestamo.plazo; i++) {
          if (parseFloat(formaPago) !== 30) {
            if (this.prestamo.diasExcluir === 2) { // Excluir domingo
              fechaInicia.add((fechaInicia.day() === 0 ? 1 : 0), 'day');
            } else if (this.prestamo.diasExcluir === 3) { // Excluir sabado y domingo

              fechaInicia.add(
                (fechaInicia.day() === 6 ? 2 : (fechaInicia.day() === 0 ? 1 : 0)),
                'day'
              );
            }
          }

          if (i === this.prestamo.plazo) {
            saldoPrestamo = interes + this.prestamo.capital;

          }
          this.tablaAmortizacion.push({
            numero_cuota: i,
            fechaVence: fechaInicia.format(),
            capital: Math.ceil(i === this.prestamo.plazo ? this.prestamo.capital : 0),
            interes: Math.ceil(interes),
            montoCuotas: Math.ceil((i === this.prestamo.plazo ? this.prestamo.capital : 0) + interes),
            saldoPrestamo: (i === parseFloat(this.prestamo.totalCuotas)) ? 0 : Math.ceil(saldoPrestamo)
          });
          // total interes
          this.prestamo.totalInteres += Math.ceil(interes);
          // Monto total
          this.prestamo.montoTotal += Math.ceil(interes);

          // monto cuotas
          this.prestamo.montoCuotas = this.prestamo.capital + interes;


          if (parseFloat(formaPago) === 30) {
            fechaInicia.add(1, 'month');

          } else {
            if (this.prestamo.diasExcluir === 2) { // Excluir domingo
              fechaInicia.add(parseFloat(formaPago) + (fechaInicia.day() === 0 ? 1 : 0), 'day');
            } else if (this.prestamo.diasExcluir === 3) { // Excluir sabado y domingo

              fechaInicia.add(
                parseFloat(formaPago) + (fechaInicia.day() === 6 ? 2 : (fechaInicia.day() === 0 ? 1 : 0)),
                'day'
              );

            } else {
              fechaInicia.add(parseFloat(formaPago), 'day');
            }
          }
        }


      }
      if (this.prestamo.tipoInteres === 'Solo capital') {
        // Plazo en dias
        this.prestamo.plazoEnDias = parseFloat(this.prestamo.plazo) * parseFloat(this.prestamo.tipoPlazo);

        // total de cuotas
        this.prestamo.totalCuotas = 1;

        // interes acomulado
        this.prestamo.interesAcomulado = parseFloat(this.prestamo.plazoEnDias) / 30 *
          parseFloat((this.prestamo.tazaInteres ? this.prestamo.tazaInteres : 0));


        const interes = (this.prestamo.tazaInteres / 100) * this.prestamo.capital;
        // total interes
        this.prestamo.totalInteres = interes;

        this.tablaAmortizacion.push({
          numero_cuota: 1,
          fechaVence: fechaInicia.format(),
          capital: Math.ceil(this.prestamo.capital),
          interes: Math.ceil(interes),
          montoCuotas: Math.ceil(this.prestamo.capital + interes),
          saldoPrestamo: 0
        });
        // monto cuotas
        this.prestamo.montoCuotas = this.prestamo.capital + interes;
        // tslint:disable-next-line:comment-format
        //total prestado
        this.prestamo.montoTotal = this.prestamo.capital + interes;
      }

    } else {
      this.tablaAmortizacion = [];
      // this.prestamo.capital = '';
      this.prestamo.totalInteres = 0;
      this.prestamo.montoCuotas = 0;
      this.prestamo.montoTotal = 0;
    }

    const data1 = {
      tipo: this.prestamo.tipoGastoCierre,
      monto_gasto_cierre: this.gasto,
      capital_prestamo: this.prestamo.capital,
      monto_incremento: this.montoIncremento
    };

    this.prestamo.gastoCierre = this._prestamo.calcularGastoCierre(data1);
    this.gastoC = this.prestamo.gastoCierre;


  }

  cambiarFechaTermina() {

    const fechaInicia = new Date(this.fechaPrestamo.year, this.fechaPrestamo.month - 1, this.fechaPrestamo.day);
    fechaInicia.setDate( fechaInicia.getDate() + parseFloat(this.prestamo.formaPago) );
    this.fechaInicia = {year: fechaInicia.getFullYear(), month: fechaInicia.getMonth() + 1, day: fechaInicia.getDate()};

    this.formChange();
  }

  editarPrestamo() {
    if (this.form.valid && this.tablaAmortizacion.length > 0) {
      this.loading = true;

      this.prestamo.formaPago = (this.otraFormaPago && this.prestamoFormaPago ? this.prestamoFormaPago : this.prestamo.formaPago);

      const fechaPrestamo = new Date(this.fechaPrestamo.year,
        this.fechaPrestamo.month - 1,
        this.fechaPrestamo.day).toString().split('GMT')[0];

      const fechaInicia = new Date(this.fechaInicia.year,
        this.fechaInicia.month - 1,
        this.fechaInicia.day).toString().split('GMT')[0];

      this.form.get('fechaPrestamo').setValue(fechaPrestamo);
      this.form.get('fechaInicia').setValue(fechaInicia);
      this.form.get('fechaVence').setValue(this.tablaAmortizacion[this.tablaAmortizacion.length - 1].fechaVence);
      console.log(this.prestamo)
      this._prestamo.editarPrestamo(this.form.value, this.prestamo, this.tablaAmortizacion)
      .subscribe(res => {
      this.loading = false;

        if (res) {
          this.modals.correctoModalJquery('Préstamo modificado con éxito',
            'green', 'modern', 'fa fa-usd fa-fw', 'El préstamo ha sido editado con éxito.');
          this.router.navigate(['/prestamo', res.ID_PRESTAMO]);
        }
      }, (err) => {
        this.loading = false;

        if (err) {
          this.modals.validacionesModalJquery('Error', err.error, 'red');
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/prestamos/editar/editar.component.ts